import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=29c45424&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=29c45424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c45424",
  null
  
)

export default component.exports